/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Contactsupport1Inputs */

const en_questionnaire_contactsupport1 = /** @type {(inputs: Questionnaire_Contactsupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please contact support.`)
};

const fr_questionnaire_contactsupport1 = /** @type {(inputs: Questionnaire_Contactsupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez contacter le support.`)
};

/**
* | output |
* | --- |
* | "Please contact support." |
*
* @param {Questionnaire_Contactsupport1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_contactsupport1 = /** @type {((inputs?: Questionnaire_Contactsupport1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Contactsupport1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_contactsupport1(inputs)
	return fr_questionnaire_contactsupport1(inputs)
});
export { questionnaire_contactsupport1 as "questionnaire_contactSupport" }